<template>
<div>
  <h3>AR Publisher</h3>
  <universal-selector
      class="mt-2"
      @addItem="selectProject"
      list-name="arpublisherProjects"
      store-name="Project"
      filter-attribute="name"
      :limit-by-organization-id="organizationId"
      tag-icon="users"
  />
  <div class="vform-label white mt-2">{{ $t('selectedProject') }}</div>
  {{ selectedProject ? selectedProject.name : '-' }}
  <slide-selector
      v-if="selectedProject"
      class="mt-2"
      :project-id="selectedProject.id"
      @slideSelected="selectSlide"
  />
  <div class="w-100" />
  <div @click="publishModelsToWebapp" class="settings-button d-inline-block mt-2 switched-colors">{{ $t('publish') }}</div>
</div>
</template>

<script>
import UniversalSelector from "@/components/organizations/UniversalSelector.vue";
import SlideSelector from "@/components/SlideSelector.vue";
export default{
  name: "ArPublisher",
  components: {
    UniversalSelector,
    SlideSelector
  },
  props: {
    organizationId: {
      type: String,
      default: null
    },
    appId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      selectedProject: null,
      selectedSlide: null,
    };
  },
  methods: {
    selectProject(project) {
      this.selectedProject = project;
      this.selectedSlide = null;
    },
    selectSlide(slideId) {
      this.selectedSlide = slideId;
    },
    async publishModelsToWebapp() {
      await this.$store.dispatch('clientPublishModelsToApp', {
        id: this.selectedProject.id,
        cid: this.appId,
        slideId: this.selectedSlide
      }).then(() => {
        this.$toasted.show(this.$t('modelsPublished'), {
          type: 'success',
          duration: 5000
        });
      }).catch(error => {
        this.$toasted.show(this.$t('errorPublishingModels') + error.message, {
          type: 'error',
          duration: 5000
        });
      });
    },
  }
}
</script>

<style scoped lang="scss">

</style>